export default {
    select_size: "Wähle eine Größe",
    required: "Pflichtfeld",
  };
  